import { BaseLayout, Head } from '@/components/layouts'
import { ArtistThemeProvider } from '@/components/styles'
import { useRouter, useTranslation } from '@/core'
import { Template } from '@/core/architecture'

import { ArtistMembershipPaymentEditForm } from './ArtistMembershipPaymentEditForm'

export * from './fragments'

import {
  ExpiredCardModal,
  PaymentErrorModal,
  Require3DSecureModal,
} from '@/components/organisms/functionals/PaymentErrorModal'

import { Action, State } from '../viewModel'

export const ArtistMembershipPaymentEditTemplate: Template<State, Action> = ({
  state,
  onSubmit,
  onSubmitDeletePayment,
  onSubmitCreatePayment,
  onCloseRequire3DSecureModal,
  onCloseExpiredCardModal,
  onClosePaymentErrorModal,
}) => {
  const { t } = useTranslation('artistMembershipPaymentEdit')
  const { routerNames } = useRouter()

  return (
    <ArtistThemeProvider artistId={state.artistId}>
      <Head title={routerNames.ArtistMembershipPurchaseProceed} />
      <BaseLayout
        header={{
          back: true,
          title: t('title', '支払い方法を変更'),
        }}
      >
        {!!state.plans?.length && !!state.patron && (
          <ArtistMembershipPaymentEditForm
            plans={state.plans}
            patron={state.patron}
            paymentSource={state.paymentSource}
            onSubmit={onSubmit}
            loading={state.loading}
            submittingCreatePayment={state.submittingCreatePayment}
            submitting={state.submitting}
            onSubmitDeletePayment={onSubmitDeletePayment}
            onSubmitCreatePayment={onSubmitCreatePayment}
          />
        )}
        <Require3DSecureModal
          open={state.openRequire3DSecureModal}
          onClose={onCloseRequire3DSecureModal}
        />

        <ExpiredCardModal
          open={state.openExpiredCardModal}
          onClose={onCloseExpiredCardModal}
        />

        <PaymentErrorModal
          open={state.openPaymentErrorModal}
          onClose={onClosePaymentErrorModal}
        />
      </BaseLayout>
    </ArtistThemeProvider>
  )
}
